import React, { useState, useRef, useEffect } from "react";
import ReactCountryFlag from "react-country-flag";
import styles from "./index.module.scss";
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { alpha3ToAlpha2 } from 'i18n-iso-countries';
import instance from '../../../services/httpRequest';
import {apiInstance as Axios} from '../../../api/requestInterceptor';
import actions from '../../../redux/actions';
import { FORD_COUNTRIES } from "../../../constants/variants";
import { ICountry, Replacement } from "../../../interface";
import localesReplacement from '../../../utils/localesReplacement';

interface IProps {
  replacements: Replacement;
}

const CountrySelector = (props: IProps) => {

  const { replacements } = props;
  const country = useSelector((state: any) => state.country);

  const [ params ] = useSearchParams();
  const countryCode = params.get('countryCode');
  const variant = params.get('variant');

  const ref = useRef<any>();

  const [show, setShow] = useState<boolean>(false);

  const dispatch = useDispatch();

  const toggleShow = () => {
    if (!show && ref) {
      ref.current.style.display = 'block';
      ref.current.style.maxHeight = '500px';
    }
    else {
      ref.current.style.maxHeight = '0';
    }
    setShow(!show);
  };

  useEffect(() => {
    if (!FORD_COUNTRIES.find((c: ICountry) => country.isoCode === c.isoCode)) {
      const newCountry = FORD_COUNTRIES.find((c: ICountry) => c.isoCode === 'GBR');
      if (newCountry) {
        changeCountry(newCountry);
      }
    }
  }, []);

  useEffect(() => {
    const newCountry = FORD_COUNTRIES.find((country: ICountry) => country.isoCode === countryCode);
    if (newCountry) {
      changeCountry(newCountry);
    }
  }, [countryCode]);

  const changeCountry = (country: ICountry) => {
    const { setCountry, setLang } = actions;
    const lang = country.defaultLanguage.isoCode;

    dispatch(setCountry(country));
    dispatch(setLang(lang));

    (instance.defaults.headers as any).countryCode = country.isoCode;
    (instance.defaults.headers as any).languageCode = lang;
    (instance.defaults.headers as any).externalName = variant;
    (Axios.defaults.headers as any).externalName = variant;
    (Axios.defaults.headers as any).languageCode = lang;
    (Axios.defaults.headers as any).countryCode = country.isoCode;
    localStorage.setItem('languageCode', lang);
    localStorage.setItem('countryCode', country.isoCode);
    if (ref) {
      ref.current.style.maxHeight = '0';
    }    
    setShow(false);
  };

  const selectedCountry = FORD_COUNTRIES.find((c: ICountry) => c.id === country.id);

  return (
    <div>
      <div className={styles['wrapper-select']} onClick={toggleShow}>
        <ReactCountryFlag
          style={{
            width: "auto",
            height: 'auto'
          }}
          svg
          countryCode={alpha3ToAlpha2(country?.isoCode ?? "GBR") ?? 'UK'}
          aria-label={localesReplacement(replacements, country?.name)}
        />
      </div>
      <ul ref={ref} className={show ? styles.container : styles.hidden}>
        <li className={styles.title}> {localesReplacement(replacements, 'Suggested Country')} </li>
        <li className={styles.selected}>
          <div className={styles.wrapper}>
            <ReactCountryFlag
              style={{
                width: "auto",
                height: "auto",
              }}
              svg
              countryCode={alpha3ToAlpha2(country?.isoCode ?? "GBR") ?? 'UK'}
              aria-label={localesReplacement(replacements, country?.name)}
            />
          </div>
          <span className={styles.country}>{localesReplacement(replacements, selectedCountry?.name ?? '')}</span>
        </li>
        <li className={styles.title}> {localesReplacement(replacements, 'Choose Country')} </li>
        {FORD_COUNTRIES.filter((c) => c.id !== country?.id).map(
          (country) => {
            return (
              <li key={country.name} onClick={() => changeCountry(country)}>
                <div className={styles.wrapper}>
                  <ReactCountryFlag
                    style={{
                      width: "auto",
                      height: "auto",
                    }}
                    svg
                    countryCode={alpha3ToAlpha2(country?.isoCode ?? "GBR") ?? 'UK'}
                    aria-label={localesReplacement(replacements, country.name)}
                  />
                </div>
                <span className={styles.country}> {localesReplacement(replacements, country.name)} </span>
              </li>
            );
          }
        )}
      </ul>
    </div>
  );
};

export default CountrySelector;
